<template>
    <div class="bsdc-config-items">
        <div
            class="bsdc-config-item"
            v-for="(product, index) in products"
            :key="index"
        >
            <DiamondCard
                :product="product"
                @selected="emit('selected', product)"
                :checked="product.id == selectedDiamondId"
            />
        </div>
    </div>

    <slot name="end" />
</template>

<script setup>
    import DiamondCard from "@js/Components/DiamondCard.vue";

    defineProps({
        products: Object,
        selectedDiamondId: Number,
    });

    const emit = defineEmits(['selected']);
</script>

<style>
    @reference "../../css/app.css";

    .bsdc-config-items {
        @apply bsdc:flex bsdc:flex-col bsdc:gap-3;
    }
</style>
